import * as React from "react";
import { styled } from "../../ui/theme";

export interface Props {
  colorScale: (string | number)[];
}

type Item = {
  color: string;
  min: number;
  max: number;
};

export default function Legend({ colorScale }: Props) {
  let scale: Item[] = [];
  for (let i = 0; i < colorScale.length - 2; i += 2) {
    scale.push({
      color: colorScale[i + 1] + "",
      min: Math.round(colorScale[i] as number),
      max: Math.round(colorScale[i + 2] as number)
    });
  }

  return (
    <Container>
      {scale.map((s, n) => (
        <Entry key={n} style={{ backgroundColor: s.color }}>
          {s.min} - {s.max}
        </Entry>
      ))}
    </Container>
  );
}

const Container = styled.ul`
  list-style: none;
  border-radius: 6px;
  overflow: hidden;
`;

const Entry = styled.li`
  font-size: 8px;
  padding: 0 4px;
  line-height: 14px;
  margin: 0;
  text-align: center;
`;
